import { createSelector } from 'reselect';
import { initialState } from '../reducers/warehouse';
import { peek, selector } from '../selectorHelpers';
import { selectPartnerConfig } from './partnerSelectors';

export const selectWarehouse = (state) => state.get('warehouse', initialState);

export const warehouseSelectAddress = selector(
  selectWarehouse,
  peek('data', 'warehouse_address'),
);
export const warehouseSelectUserFfid = selector(
  selectWarehouse,
  peek('data', 'user_ffid'),
);
export const warehouseSelectLoading = selector(
  selectWarehouse,
  peek('isLoading'),
);

// Warehouse branches
const warehouseSelectAllBranches = selector(
  selectWarehouse,
  peek('warehouseBranches'),
);

// Partner allowlist read from Redux state — selector is a pure function of
// state. createSelector memoizes on both inputs; the output recomputes only
// when branches or partner config change. Partner config is stable within a
// session, so the Set construction cost is paid once per Redux state update
// at most.
export const warehouseSelectBranches = createSelector(
  [warehouseSelectAllBranches, selectPartnerConfig],
  (branches, partner) => {
    const allowedBranches = new Set(partner.branches.sbNames);
    return branches.filter((b) => allowedBranches.has(b.get('sb_name')));
  },
);

export const warehouseSelectBranchesLoading = selector(
  selectWarehouse,
  peek('isLoadingWarehouseBranches'),
);
